<template>
  <div :class="'profile-layout sample-profile type-profile'">
    <sample-navbar></sample-navbar>
    <div class="wrapper" :class="[{ 'nav-open': $sidebar.showSidebar }]">
      <notifications></notifications>
      <app-side-bar
        :mini="true"
        :active-color="sidebarBackground"
        :background-image="sidebarBackgroundImage"
        :data-background-color="sidebarBackgroundColor"
      >
        <!-- <mobile-menu></mobile-menu> -->
        <template slot="links" v-if="!spif">
          <sidebar-item
            :link="{
              name: 'About the Data',
              icon: 'help',
              path: 'about',
            }"
          ></sidebar-item>
          <sidebar-item
            :class="!loading ? '' : 'disabled-item'"
            :link="{
              name: 'Information',
              icon: 'chat_bubble',
              path: 'introduction',
            }"
          ></sidebar-item>
          <div v-popover.right="{ name: 'financial-fundamentals' }">
            <sidebar-item
              :class="!loading ? '' : 'disabled-item'"
              :link="{
                name: 'Financials',
                icon: 'analytics',
                path: 'financial-fundamentals',
              }"
            ></sidebar-item>
          </div>
          <div v-popover.right="{ name: 'ratios' }">
            <sidebar-item
              :class="!loading ? '' : 'disabled-item'"
              :link="{
                name: 'Ratios',
                icon: 'scatter_plot',
                path: 'ratios',
              }"
            ></sidebar-item>
          </div>
          <sidebar-item
            :class="!loading ? '' : 'disabled-item'"
            :link="{
              name: 'Valuation Multples',
              icon: 'query_stats',
              path: 'valuation-multiples',
            }"
          ></sidebar-item>
        </template>
        <template slot="links" v-if="spif">
          <sidebar-item
            :class="!loading ? '' : 'disabled-item'"
            :link="{
              name: 'About the Data',
              icon: 'help',
              path: 'about',
            }"
          ></sidebar-item>
          <sidebar-item
            :class="!loading ? '' : 'disabled-item'"
            :link="{
              name: 'Information',
              icon: 'chat_bubble',
              path: 'introduction',
            }"
          ></sidebar-item>
          <div v-popover.right="{ name: 'profit-and-loss' }">
            <sidebar-item
              :class="!loading ? '' : 'disabled-item'"
              :link="{
                name: 'Profit & Loss',
                icon: 'analytics',
                path: 'profit-and-loss',
              }"
            ></sidebar-item>
          </div>
          <div v-popover.right="{ name: 'ratios' }">
            <sidebar-item
              :class="!loading ? '' : 'disabled-item'"
              :link="{
                name: 'Ratios',
                icon: 'scatter_plot',
                path: 'ratios',
              }"
            ></sidebar-item>
          </div>
          <sidebar-item
            :class="!loading ? '' : 'disabled-item'"
            :link="{
              name: 'Cash Tables',
              icon: 'collections_bookmark',
              path: 'cash-tables',
            }"
          ></sidebar-item>
          <sidebar-item
            :class="!loading ? '' : 'disabled-item'"
            :link="{
              name: 'Valuation Multiples',
              icon: 'query_stats',
              path: 'valuation-multiples',
            }"
          ></sidebar-item>
        </template>
      </app-side-bar>
      <div class="main-panel">
        <div :class="{ content: !$route.meta.hideContent }">
          <div v-if="!isAboutRoute" class="content">
            <PulseLoader
              :loading="loading"
              :class="{ hide: !loading }"
              quote="Action is the foundational key to all success"
              author="Pablo Picasso"
              profession="Spanish Painter"
              img="picasso.jpg"
            ></PulseLoader>
          </div>
          <zoom-center-transition :duration="200" mode="out-in">
            <div class="row">
              <!-- your content here -->
              <router-view :headerData="headerData" v-if="!loading || isAboutRoute" />
             <!-- <PulseLoader :loading="loading" :class="{ hide: !loading }" class="pulse"></PulseLoader>-->
            </div>
          </zoom-center-transition>
        </div>
        <content-footer v-if="!$route.meta.hideFooter"></content-footer>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
    document.getElementsByClassName(className)[0].scrollTop = 0;
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

function reinitScrollbar() {
  let docClasses = document.body.classList;
  let isWindows = navigator.platform.startsWith('Win');
  if (isWindows) {
    // if we are on windows OS we activate the perfectScrollbar function
    initScrollbar('sidebar');
    initScrollbar('sidebar-wrapper');
    initScrollbar('main-panel');

    docClasses.add('perfect-scrollbar-on');
  } else {
    docClasses.add('perfect-scrollbar-off');
  }
}

function initSidebar() {
  document.body.classList.toggle('sidebar-mini');
}

import SampleNavbar from './SampleNavbar.vue';
import ContentFooter from './ContentFooter.vue';
// import MobileMenu from './Extra/MobileMenu.vue';
// import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { PulseLoader } from '@/components';
import Vuex, { mapActions } from 'vuex';
import axios from 'axios';

export default {
  name: 'sample-profile-layout',
  components: {
    SampleNavbar,
    ContentFooter,
    // MobileMenu,
    PulseLoader,
  },
  data() {
    return {
      sidebarBackgroundColor: 'grey',
      sidebarBackground: 'green',
      sidebarBackgroundImage:
        process.env.VUE_APP_BASE_URL + '/img/sidebar-2.jpg',
      sidebarMini: true,
      sidebarImg: true,
      image: process.env.VUE_APP_BASE_URL + '/img/laravel-vue.svg',
      roles: [],
      loading: true,
      isAboutRoute: false,
      headerData: {
        area: null,
        bznaics: "238220.000000",
        client_logo: null,
        client_name: null,
        developer_logo: null,
        developer_name: null,
        error: false,
        errorCode: "none",
        industry: "Plumbing, Heating, and Air-Conditioning Contractors",
        isReport: false,
        sales_class: "$1m - $2.49m",
        sector: "Construction",
        title: "Industry Financial Profile"
      },
      spif: false
    };
  },
  methods: {
    ...mapActions({
      alertSuccess: 'alerts/success',
      alertError: 'alerts/error',
    }),
    async init() {
      this.loading = true;

      await this.$store.dispatch('sample/getIFProfile').then((res) => {
        this.$store.commit('user/SET_PROFILE', res);
        this.getHeaderData();
        this.loading = false;
      });
    },
    checkRoute() {
      if (this.$route.name === 'SampleIFAbout')
        return true;

      return false;
    },
    getHeaderData() {
      axios
        .get(process.env.VUE_APP_API_BASE_URL + '/info/productHeader', {
          params: {
            product_id: this.profile.reportID,
          },
        })
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode +
              `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/IMR_available" <br>`
            );
            throw new Error(
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode
            );
          }
          this.headerData = res.data;
        });
    },
  },
  updated() {
    reinitScrollbar();
  },
  mounted() {
    reinitScrollbar();
    initSidebar();
    this.isAboutRoute = this.checkRoute()
    this.init();
  },
  computed: {
    ...Vuex.mapState({
      profile: (state) => state.user.profile,
      // spif: (state) => state.user.profile.spif,
      // me: (state) => state.profile.me,
    }),
  },
  watch: {

  },
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}
.main-navbar .md-toolbar-section-end .button-container.main-nav-cta.notifications ul li:before,
.main-navbar .md-toolbar-section-end .button-container.main-nav-cta.notifications ul li h5,
.if-profile .truncated_header ul li h6 .md-icon,
.if-profile .button-box .access-button .md-ripple i,
.sidebar.app-sidebar .sidebar-wrapper .nav li a.nav-link i{
  color: #002277 !important;
}

.fundamentals_wpr .extra_info_area .md-card .md-card-content p{
  color: black !important;
  font-size: 12px !important;
  }
</style>
